import React, { type ReactNode } from 'react'
import { ThemeProvider } from 'styled-components'

import type { AutomatedComponentsTheme } from './themeAutomator'
import type { ComponentsMode, ComponentsThemeBase } from './types'
import { lightTheme } from './const'

export type ComponentsThemeProviderProps = {
  theme?: Partial<ComponentsThemeBase>
  automatedTheme?: AutomatedComponentsTheme
  mode?: ComponentsMode
  children: ReactNode
}

export const ComponentsThemeProvider = ({
  theme,
  automatedTheme,
  mode = 'opacity',
  children,
}: ComponentsThemeProviderProps) => (
  <ThemeProvider theme={{ mode, ...{ ...lightTheme, ...theme }, automated: automatedTheme }}>
    {children}
  </ThemeProvider>
)
